import {ActionTypes} from "modules/redux_types";
import createReduxPromiseActionType from "utils/create_redux_promise_action_type";

const actionTypes = {};

const types = [
  "SEARCHER_QUERY_RUN",
  "SEARCHER_QUERY_CLEAR",
  "EMBEDDING_TOPICS_FETCH",
  "DOCUMENTS_FETCH",
] as const;

types.forEach(type => createReduxPromiseActionType(actionTypes, type));

export type ActionType = typeof types[number];

export type SearcherActionTypes = ActionTypes<ActionType>;

export default actionTypes as SearcherActionTypes;
